import { useState } from "react";
import { updatePaymentById } from "../../../apis/customers";
import Select from "react-select";
import { useLocation } from "react-router";
import CryptoJS from "crypto-js";
const EmisData = () => {
  const paymentValues = {
    paymentAmount: "",
    penaltyAmount: "",
    discount: "",
  };

  const [customerData, setCustomerData] = useState<any>();
  const [products, setProducts] = useState<any>();
  const [selectedOption, setSelectedOption] = useState<any>();
  const [loanNewData, setLoanNewData] = useState<any>();
  const [paymentFormData, setPaymentFormData] = useState(paymentValues);
  const { paymentAmount, penaltyAmount, discount } = paymentFormData;

  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const encryptedData = queryParams.get("data");

  let decryptedData = null;
  if (encryptedData) {
    try {
      const bytes = CryptoJS.AES.decrypt(
        decodeURIComponent(encryptedData),
        "emis"
      );
      decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    } catch (error) {
      console.error("Error decrypting data:", error);
    }
  }
  const paymentMode = [
    { value: "Select", label: "Select" },
    { value: "BANK", label: "BANK" },
    { value: "UPI", label: "UPI" },
    { value: "CASH", label: "CASH" },
  ];
  const handleSelect = (option: any | null) => {
    setSelectedOption(option || undefined);
  };
  const handleOnChangePayment = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setPaymentFormData({ ...paymentFormData, [name]: value });
  };
  const handlePayment = async (event: any) => {
    event.preventDefault();
    const mtIdString = sessionStorage.getItem("info");
    let mtId: { id: string; user_id: string } | null = null;
    if (mtIdString) {
      try {
        mtId = JSON.parse(mtIdString);
      } catch (error) {
        console.error("Failed to parse sessionStorage info:", error);
      }
    }
    const date = new Date();
    const formattedDate = date.toISOString().split("T")[0];
    const payload = {
      paymentMode: selectedOption?.value,
      paymentAmount: Number(paymentAmount),
      paymentDate: formattedDate,
      customerId: decryptedData?.customerId,
      loanId: decryptedData?.loanId,
      emiId: decryptedData?.data?.id,
      status: "paid",
      penaltyAmount: Number(penaltyAmount),
      discount: Number(discount),
      user_id: mtId?.user_id,
    };

    try {
      const response = await updatePaymentById(
        decryptedData?.customerId,
        payload
      );
      if (response.status === true) {
      }
    } catch (error) {
      console.error(error, "error");
    }
  };
  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="card">
          <div className="card-body p-0">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
              <div className="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                <form
                // onSubmit={handlePayment}
                >
                  <div className="contact-grids-tab">
                    <ul
                      className="nav nav-underline"
                      id="myTab2"
                      role="tablist"
                    >
                      <li className="nav-item" role="presentation">
                        <button
                          className="nav-link active"
                          id="info-tab2"
                          data-bs-toggle="tab"
                          data-bs-target="#basic-info2"
                          type="button"
                          role="tab"
                          aria-selected="true"
                        >
                          Payment Information
                        </button>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content" id="myTabContent2">
                    <div
                      className="tab-pane fade show active"
                      id="basic-info2"
                      role="tabpanel"
                      aria-labelledby="info-tab2"
                      tabIndex={0}
                    >
                      <div className="modal-body pb-0 ">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Emi Amount
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="DisbursementAmount"
                                value={decryptedData?.data?.amount || 0}
                                className="form-control"
                                disabled
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Payment Amount
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="paymentAmount"
                                value={paymentAmount}
                                onChange={handleOnChangePayment}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Due Date
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                value={decryptedData?.data?.due_date}
                                className="form-control"
                                disabled
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Penalty Amount
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="penaltyAmount"
                                value={penaltyAmount}
                                onChange={handleOnChangePayment}
                                className="form-control"
                              />
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Discount
                                <span className="text-danger"> *</span>
                              </label>
                              <input
                                type="text"
                                name="discount"
                                value={discount}
                                onChange={handleOnChangePayment}
                                className="form-control"
                              />
                            </div>
                          </div>

                          <div className="col-md-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Select Payment Mode
                              </label>
                              <Select
                                classNamePrefix="react-select"
                                className="select"
                                options={paymentMode}
                                value={selectedOption}
                                onChange={handleSelect}
                                placeholder="Payment Mode"
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-outline-light border me-2"
                        >
                          Cancel
                        </button>
                        <button
                          className="btn btn-primary"
                          onClick={handlePayment}
                        >
                          Submit{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default EmisData;
